\rentware-select
    width: 100%

.DefaultWrapper
    position: relative
    height: 40px
    width: 100%
    min-width: 200px
    margin: 0
    border: 1px solid rgb($globalSettingsStrokeSecondary)
    border-radius: 0 $globalButtonRounding $globalButtonRounding $globalButtonRounding
    box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)
    background-color: rgb($globalSettingsBackgroundPrimary)
    vertical-align: top
    font-size: 14px
    font-weight: 400
    stroke: rgb($globalSettingsFontSecondary)
    fill: rgb($globalSettingsFontSecondary)
.DefaultWrapperActive
    &:hover
        border: 1px solid rgb($globalSettingsStrokePrimary)
        stroke: rgb($globalSettingsFontPrimary)
        fill: rgb($globalSettingsFontPrimary)
    &:focus-within
        outline: none
        border: 1px solid rgb($globalSettingsStrokePrimary)
        stroke: rgb($globalSettingsFontPrimary)
        fill: rgb($globalSettingsFontPrimary)
.DefaultWrapperDisabled
    background: rgb($globalSettingsBackgroundTertiary)
    cursor: default

.ConfigWrapper
    position: relative
    height: 80px
    width: 100%
    min-width: 250px
    margin: 0
    border-top: 1px solid rgb(222, 222, 226)
    background-color: rgb(255,255,255)
    font-size: 14px
    font-weight: 400
    color: rgb(97, 95, 115)
    stroke: rgb(97, 95, 115)
    .DisabledContainer
        opacity: 0.5
        pointer-events: none
        cursor: default
    .ConfigTextContainer
        min-width: 0
        display: flex
        flex-direction: column
        flex: 1
        .ConfigLabel
            font-size: 12px
            font-weight: 700
            color: rgb( 97, 95, 115)
            cursor: pointer
        .ConfigInput
            display: flex
            justify-content: space-between
            align-items: center

.TransparentWrapper
    position: relative
    display: flex
    justify-content: center
    align-items: center
    box-shadow: none
    &:hover
        opacity: 0.85
    svg
        stroke: none

.ConfigWrapperActive
    &:hover
        border-top: 1px solid rgb(208, 208, 214)
        background-color: rgb(245,245,245)
        color: rgb(70, 67, 91)
        stroke: rgb(70, 67, 91)
    &:focus-within
        outline: none
        border-top: 1px solid rgb(208, 208, 214)
        color: rgb(70, 67, 91)
        stroke: rgb(70, 67, 91)

.ConfigWrapperDisabled
    color: rgb(125, 123, 140)
    stroke: rgb(125, 123, 140)

.NewConfigWrapper
    position: relative
    height: 100%
    width: 100%
    min-width: 0
    margin: 0
    background-color: rgb(255,255,255)
    font-size: 14px
    font-weight: 400
    color: rgb(97, 95, 115)
    stroke: rgb(97, 95, 115)
    .DisabledContainer
        opacity: 0.5
        pointer-events: none
        cursor: default
    .ConfigTextContainer
        min-width: 0
        display: flex
        flex-direction: column
        flex: 1
        .ConfigLabel
            font-size: 12px
            font-weight: 700
            color: rgb( 97, 95, 115)
            white-space: nowrap
            overflow: hidden
            text-overflow: ellipsis
            cursor: pointer
        .ConfigInput
            display: flex
            justify-content: space-between
            align-items: center

.NewConfigWrapperActive
    cursor: pointer
    &:hover
        background-color: rgb(245,245,245)
        color: rgb(70, 67, 91)
        stroke: rgb(70, 67, 91)
    &:focus-within
        outline: none
        color: rgb(70, 67, 91)
        stroke: rgb(70, 67, 91)

.NewConfigWrapperDisabled
    cursor: default
    color: rgb(125, 123, 140)
    stroke: rgb(125, 123, 140)

.SimpleWrapper, .SearchWrapper
    position: relative
    width: 100%
    margin: 0
    vertical-align: top
    font-size: 14px
    font-weight: 400
    border-radius: $globalButtonRounding
    stroke: rgb($globalSettingsFontSecondary)
    transition: background 0.8s
    color: rgb($globalSettingsFontPrimary)
.SimpleWrapperActive, .SearchWrapperActive
    cursor: pointer
    &:hover
        background: rgb($globalSettingsBackgroundSecondary)
        stroke: rgb($globalSettingsFontPrimary)
    &:focus-within
        outline: none
        background: rgb($globalSettingsBackgroundSecondary)
        stroke: rgb($globalSettingsFontPrimary)

.SearchWrapper
    height: 40px

.VariationsWrapper
    width: calc(100% + 40px)
    position: relative
    margin: 0 -20px -1px
    vertical-align: top
    font-size: 14px
    font-weight: 400
    stroke: rgb($globalSettingsFontSecondary)
    color: rgb($globalSettingsFontTertiary)
    transition: background 0.8s
    box-sizing: border-box
    border-top: 1px solid rgb($globalSettingsStrokeSecondary)
    border-bottom: 1px solid rgb($globalSettingsStrokeSecondary)
.VariationsWrapperWrapperActive
    &:focus-within
        stroke: rgb($globalSettingsFontPrimary)
        color: rgb($globalSettingsFontSecondary)
        border-top: 1px solid rgb($globalSettingsStrokePrimary)
        border-bottom: 1px solid rgb($globalSettingsStrokePrimary)
    &:hover
        z-index: 1
        color: rgb($globalSettingsFontSecondary)
        stroke: rgb($globalSettingsFontPrimary)
        border-top: 1px solid rgb($globalSettingsStrokePrimary)
        border-bottom: 1px solid rgb($globalSettingsStrokePrimary)

.Touched.Error
    border: 1px solid rgb($globalErrorBackground) !important

.Content
    width: 100%
    height: 100%
    display: flex
    align-items: center
    justify-content: space-between
    gap: 10px
    padding: 0 15px
    box-sizing: border-box

.ContentDefaultActive
    cursor: pointer

.ColorContainer
    width: 24px
    height: 24px
    border-radius: 50%
    box-shadow: 0 2px 15px rgb(200, 200, 200)
    cursor: pointer
    flex-shrink: 0

.ContentDisabled
    cursor: wait

.ContentNoChoice
    cursor: default

.ContentSimple
    padding: 0

.ContentSearch
    height: 40px
    padding: 0 10px
    transition: background 0.2s ease-in-out

.ContentVariations
    height: 40px
    padding: 0
    transition: background 0.2s ease-in-out

.ContentSearchDisabled
    background: rgb($globalSettingsBackgroundTertiary)
    color: rgb($globalSettingsFontTertiary)
    cursor: initial
    pointer-events: none
    z-index: 1
    border-radius: $globalButtonRounding
    &:focus
        outline: none
        stroke: rgb($globalSettingsStrokePrimary)

.ValueInputDefault
    flex-grow: 1
    flex-shrink: 1
    align-self: center
    user-select: none
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
    outline: none !important
    border: none !important
    box-shadow: none !important
    &:focus
        outline: none !important
        border: none !important
        box-shadow: none !important

.ValueInputConfig
    flex-grow: 1
    flex-shrink: 1
    user-select: none
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
    outline: none !important
    border: none !important
    box-shadow: none !important
    background-color: unset
    font-size: 14px
    font-weight: 400
    color: rgb(97, 95, 115)
    stroke: rgb(97, 95, 115)
    padding-left: 0
    &:focus
        outline: none !important
        border: none !important
        box-shadow: none !important

.ValueDivDefault
    flex-grow: 1
    flex-shrink: 1
    align-self: center
    user-select: none
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis

.ValueContainerConfig
    min-width: 0
    display: flex
    flex-direction: row
    align-items: center
    flex-wrap: nowrap
    flex-grow: 1
    gap: 10px
    box-sizing: border-box

.ValueContainerSimple
    display: flex
    flex-direction: row
    align-items: center
    align-self: center
    justify-content: space-between
    user-select: none
    min-width: 50px
    padding: 5px 5px 5px 10px
    box-sizing: border-box
    gap: 3px
    border: 2px solid rgba(#{$globalButtonBackgroundPrimary}, 0.6)
    border-radius: $globalButtonRounding
    stroke: $globalSettingsFontSecondary

.ValueContainerSimple--no-svg--no-border
    display: flex
    flex-direction: row
    align-items: center
    align-self: center
    justify-content: space-between
    user-select: none
    min-width: 50px
    box-sizing: border-box
    gap: 3px
    stroke: $globalSettingsFontSecondary
    &--no-svg
        padding-right: 10px


.VerticalDividerWrapper
    position: relative
    width: 2px
    align-self: stretch
    display: flex
    align-items: stretch
    margin-left: 3px

.VerticalDivider
    position: absolute
    top: -5px
    bottom: -5px
    width: 2px
    background-color: rgba(#{$globalButtonBackgroundPrimary}, 0.6)

.SmallMargin
    margin: 0 1px

.ValueContainerVariations
    min-width: 0
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between
    flex-grow: 1
    align-self: center
    user-select: none
    padding: 0 20px
    box-sizing: border-box
    gap: 5px
    .ValueContainerVariationsInner
        min-width: 0
        display: flex
        flex-direction: row
        align-items: center
        gap: 5px

.ValueContainerSearch
    min-width: 0
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between
    flex-grow: 1
    gap: 20px
    align-self: center
    user-select: none
    .ValueContainerSearchInner
        min-width: 0
        display: flex
        flex-direction: row
        align-items: center
        gap: 20px

.ValueContainerSearchSpan
    min-width: 0
    overflow: hidden
    text-overflow: ellipsis
    display: -webkit-box
    -webkit-line-clamp: 1
    -webkit-box-orient: vertical

.EllipsisValue
    min-width: 0
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis

.BoldSpan
    font-weight: 700

.toggle-wrapper
    flex-shrink: 0
    padding: 8px 12px

.NoStroke
    stroke: none !important

.Time
    stroke: none !important
    & > *
        transition: all 1s ease-in-out

.toggle
    width: 10px
    height: 10px
    border: 1.5px solid #B5B4BD
    border-right: none
    border-top: none
    transform: translateY(25%) rotate(-45deg)
    user-select: none

.SelectLabel
    position: absolute
    top: -1em
    left: 0
    height: 1em
    line-height: 1em
    z-index: 1
    display: inline-block
    vertical-align: text-top
    padding: 0 2px 0 0
    font-size: 12px
    font-weight: 700
    pointer-events: none
    color: rgb($globalSettingsFontTertiary)
    white-space: nowrap
    user-select: none
    border-bottom: 1px solid rgb($globalSettingsBackgroundPrimary)
    box-sizing: border-box

.Touched.LabelError
    color: rgb($globalErrorBackground) !important

.SelectExpandedContainer
    position: absolute
    left: -1px
    z-index: $indexPicker
    width: calc(100% + 2px)
    animation: fadeIn 350ms
    &.closing
        animation: fadeOut 200ms 200ms ease-in-out forwards
.SelectExpandedMargin
    left: 5px
    width: calc(100% - 10px)

.MenuWrapper
    background-color: rgb($globalSettingsBackgroundPrimary)
    overflow: hidden
    box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)
    display: inline-block
    border: 1px rgb($globalSettingsStrokeSecondary) solid
    border-radius: $globalButtonRounding

.DefaultMenuWrapper
    width: 100%
    min-height: 50px
    margin: 16px 0

.ConfigMenuWrapper, .NewConfigMenuWrapper
    width: calc(100% - 2px)
    min-height: 80px
    margin: 1px
    margin-top: 0
    border: 1px rgb(215, 215, 220) solid
    background-color: rgb(255, 255, 255)
    box-shadow: 0 2px 15px rgb(235, 235, 235)
    box-sizing: border-box
    border-radius: 0 0 5px 5px

.SimpleMenuWrapper
    min-width: 65px
    margin-top: 5px
    box-sizing: border-box

.SearchMenuWrapper
    width: 100%
    margin-top: 22px

.VariationsMenuWrapper
    width: calc(100% + 2px)
    margin: 0 -1px

.openDown
    top: 100%
.openUp
    bottom: 100%

.SelectMenu
    max-height: 270px
    overflow-y: auto
    overflow-x: hidden

.FixedStyle
    scrollbar-color: rgb(70, 70, 91) rgb(235,235,235)
    &::-webkit-scrollbar-track
        background: rgb(235,235,235)
    &::-webkit-scrollbar-thumb
        background-color: rgb(70, 70, 91)
        border-radius: 10px
        border: 3px solid rgb(235,235,235)

.ColorInput
    outline: none
    font: inherit
    border: none
    color: #46465b
    max-width: 100px

.ColorInputError
    color: #ff0066

.Input
    width: 1px
    position: absolute
    z-index: -1
    &:focus
        outline: none
        box-shadow: none
        border: none
    &:invalid
        box-shadow: none
        border: none
        outline: none
.Hidden
    display: none

.SimpleInput, .SearchInput, .VariationsInput
    opacity: 0

.SpanNoShrink
    flex-shrink: 0

@keyframes fadeIn
    from
        opacity: 0
    to
        opacity: 1

@keyframes fadeOut
    from
        opacity: 1
    to
        opacity: 0
